import { ACCOUNT_ERROR_HANDLERS } from '@platform-frontend/account';
import { GotoError, HandleErrorsGlobalRecord } from '@platform-frontend/util';

export const MARKETPLACE_ERROR_HANDLERS: HandleErrorsGlobalRecord = {
  ...ACCOUNT_ERROR_HANDLERS,
  SOLUTION_NOT_KNOWN: new GotoError({ queryParams: { errorType: 'SOLUTION_NOT_KNOWN' }, clearNotifications: false }),
  INVALID_START_CHECKOUT_PREFERENCE: new GotoError({ queryParams: { errorType: 'INVALID_START_CHECKOUT_PREFERENCE' }, clearNotifications: false })
};
